import Localize from 'react-intl-universal';

import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import * as yup from 'yup';

import { CustomFieldTypes } from './util';

export const timeValidationRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/;

const additionalPropsBasedOnType = (customFields = []) => {
  const temp = {};
  customFields?.forEach((customField) => {
    let defaultSchema = {};
    switch (customField?.customFieldType?.id) {
      case CustomFieldTypes.DATE:
        defaultSchema = yup.date().typeError(Localize.get('Validation.dateInvalid'));
        break;

      case CustomFieldTypes.TIME:
        defaultSchema = yup
          .string()
          .matches(timeValidationRegex, Localize.get('Validation.timeInvalid'))
          .typeError(Localize.get('Validation.timeInvalid'));
        break;

      case CustomFieldTypes.DATE_TIME:
        defaultSchema = yup.date().typeError(Localize.get('Validation.dateInvalid'));
        break;

      case CustomFieldTypes.RADIO_BUTTON:
        defaultSchema = yup.object().shape({
          id: yup.number(),
          name: yup.string()
        });
        break;

      case CustomFieldTypes.DROPDOWN:
        defaultSchema = yup.number();
        break;

      case CustomFieldTypes.CHECKBOX:
        defaultSchema = yup.array().of(
          yup.object().shape({
            id: yup.number().required().nullable(true),
            name: yup.string()
          })
        );
        break;

      case CustomFieldTypes.TEXT:
        defaultSchema = yup.string();
        break;

      case CustomFieldTypes.TEXT_AREA:
        defaultSchema = yup.string();
        break;

      case CustomFieldTypes.QUANTITY:
        defaultSchema = yup.string().test(
          'is-valid',
          Localize.get('Validation.quantityDefaultValue', {
            from: customField?.fromValue,
            until: customField?.untilValue
          }),
          (value) => {
            if (!value) {
              return true;
            }
            return (
              (!customField?.fromValue || customField?.fromValue <= value) &&
              (!customField?.untilValue || value <= customField?.untilValue)
            );
          }
        );
        break;

      default:
        break;
    }

    temp[`${customField?.id}`] = customField?.isMandatory
      ? defaultSchema
          .required(Localize.get('Validation.fieldIsRequired'))
          .test('is-not-empty', Localize.get('Validation.fieldIsRequired'), (value) => {
            if (customField?.customFieldType?.id === CustomFieldTypes.CHECKBOX) {
              return value?.length > 0;
            }
            return !!value;
          })
      : defaultSchema.nullable();
  });

  return temp;
};

export default (customFields) => {
  return yup.object().shape({
    additionalInfo: yup.array().of(
      yup.object().shape({
        reference: yup.string(),
        refSign: yup.string(),
        hotelRequest: yup.boolean().notRequired(),
        arrivalDate: yup.date().when('hotelRequest', {
          is: (hotelRequest) => hotelRequest,
          then: () =>
            yup
              .date()
              .nullable()
              .required(Localize.get('Validation.dateRequired'))
              .typeError(Localize.get('Validation.dateTimeInvalid'))
              .test(
                'is-start-after-departure',
                Localize.get('Validation.endDateStartDate'),
                function (value, e) {
                  return isBefore(value, e?.parent?.departureDate);
                }
              ),
          otherwise: () => yup.date().notRequired()
        }),
        departureDate: yup.date().when('hotelRequest', {
          is: (hotelRequest) => hotelRequest,
          then: () =>
            yup
              .date()
              .nullable()
              .required(Localize.get('Validation.dateRequired'))
              .typeError(Localize.get('Validation.dateTimeInvalid'))
              .test(
                'is-after-start-one-day',
                Localize.get('Validation.endDateStartDate'),
                function (value, e) {
                  return isAfter(value, e?.parent?.arrivalDate);
                }
              ),
          otherwise: () => yup.date().notRequired()
        }),
        customFields: yup.object().shape({
          ...additionalPropsBasedOnType(customFields)
        })
      })
    )
  });
};
